import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Zap, Mail } from 'lucide-react';
import LanguageSwitcher from '@/components/LanguageSwitcher';

export default function ReportHeader({ onSendEmail, sendingEmail, isUnlocked }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <nav className="glass-nav sticky top-0 z-50 py-4">
      <div className="container mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
          <Zap className="w-6 h-6 text-primary" />
          <span className="text-xl font-light text-primary" style={{ fontFamily: 'Outfit' }}>{t('nav.brand')}</span>
        </div>
        <div className="flex items-center gap-4">
          <LanguageSwitcher />
          {isUnlocked && (
            <button
              onClick={onSendEmail}
              disabled={sendingEmail}
              className="btn-secondary px-4 py-2 rounded-md text-sm flex items-center gap-2"
              data-testid="email-report-btn"
            >
              <Mail className="w-4 h-4" />
              {sendingEmail ? t('report.sending') : t('report.emailReport')}
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
